import { render, staticRenderFns } from "./dingJIn.vue?vue&type=template&id=35823ad5&scoped=true&"
import script from "./dingJIn.vue?vue&type=script&lang=js&"
export * from "./dingJIn.vue?vue&type=script&lang=js&"
import style0 from "./dingJIn.vue?vue&type=style&index=0&id=35823ad5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35823ad5",
  null
  
)

export default component.exports